import React, { Component } from 'react';
import { Button, Modal, ModalBody } from 'reactstrap';
import ifailed from './../../../assets/pvi-benhhiemngheo/ifailed.png';
class ModalWarringDelete extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    };

    render() {
        return (
            <div style={{ overflow: 'hidden' }}>
                <Modal style={{ fontSize: 15 }} isOpen={true} centered={true} >
                    <ModalBody>
                        <div>
                            <div style={{ textAlign: 'center' }}>
                                <img src={ifailed} alt="home" width="80px" height="auto" />
                                <div style={{ fontWeight: 'bold', marginTop: '2%', fontSize: 18, textTransform: 'capitalize' }}>Xóa {this.props.dataRemove?.insuredName}?</div>
                                <div style={{ marginTop: '2%' }}>Bạn có chắc chắn XÓA <br /><b style={{ textTransform: 'capitalize' }}>{this.props.dataRemove?.insuredName}</b><br /> khỏi danh sách người được bảo hiểm?</div>
                                <div style={{ textAlign: 'center', marginTop: 15 }}>
                                    <Button onClick={() => this.props.openModalDelete(0)} style={{ width: '45%', fontSize: 12, borderRadius: 100, marginRight: 5, fontWeight: 'bold', color: '#25806D', border: '1px solid #25806D' }} outline color="#2A3790">Quay lại</Button>
                                    <Button onClick={() => this.props.openModalDelete(2)} style={{ width: '45%', fontSize: 12, background: '#25806D', borderRadius: 100, fontWeight: 'bold', color: '#ffffff' }} color="#25806D">Xác nhận</Button>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}


export default ModalWarringDelete;
